// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1AqHh","title":"ClientCherryInfo_title__1am5X","itemText":"ClientCherryInfo_itemText__3229Q"};